/** web-studio-sites D7: what the bookings list's current state requires a drawing to show: each loaded row, opening its booking. */
import type { RequiredParts } from '../../contract/required';
import type { BookingsListState } from './contract';

export const requiredParts: RequiredParts<BookingsListState> = (state) =>
  state.status !== 'ready'
    ? []
    : [...state.upcoming, ...(state.pastStatus === 'ready' ? state.past : [])].map((row) => ({
        part: 'row',
        item: row.id,
        action: 'open',
      }));
